import { modal } from "../../wagmi.config.ts";

const ConnectModal = () => {
  const handleOpenWalletModal = () => {
    modal.open();
  };

  return (
    <div className="fixed inset-0 flex items-center bg-base-200 justify-center z-50">
      <div className="rounded-2xl p-6 shadow-lg bg-base-100">
        <h3 className="text-xl font-semibold mb-4 text-base-content">
          Connection required
        </h3>
        <p className="text-sm text-secondary mb-6">
          You must connect to access the application.
        </p>
        <div className="flex justify-end gap-3">
          <button onClick={handleOpenWalletModal} className="btn btn-outline">
            Connect
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button
          className="w-full h-full cursor-default"
          aria-label="Close modal"
        ></button>
      </form>
    </div>
  );
};

export default ConnectModal;
